import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Routing from "./routes";
import LanguageUrlSync from "./components/i18n/LanguageUrlSync";
import "./assets/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/fontawesome/css/all.min.css";
import "./assets/css/meanmenu.css";
import "./assets/css/default.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";

import "./assets/css/flags.css";

function App() {
  return (
    <>
      <Router>
        <LanguageUrlSync />
        <Routing />
      </Router>
    </>
  );
}

export default App;
